var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.562,
    height: 110.589,
    viewBox: "0 0 78.562 110.589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e6a329",
    d: "M78.562,489.9H0l7.365,79.867,31.912,9.051,31.912-9.051Z",
    "data-name": "Path 275",
    transform: "translate(0 -468.229)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bf22",
    d: "M887.9,637v75.643l25.856-7.325L920.046,637Z",
    "data-name": "Path 276",
    transform: "translate(-848.623 -608.822)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M434.124,858.5H394.369L391.6,888.4l.057-.186h33.774l-1.1,12.651-10.776,3.1-10.935-3.15-.655-7.657h-9.926l1.416,15.3,20.1,5.706,20.109-5.706,2.769-30.032H400.589l.46-10.006h24.869l.372,5.733H436.3Z",
    "data-name": "Path 277",
    transform: "translate(-374.277 -820.524)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M413.563,858.5H394.369L391.6,888.4l.057-.186h21.905v-9.754H401.987l.46-10.006h11.116Zm-11.576,34.663h-9.949l1.416,15.292,20.1,5.7V903.979l-10.935-3.158Z",
    "data-name": "Path 278",
    transform: "translate(-374.277 -820.524)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M564.094,9.891H557.1v5.021h12V0h-5ZM586.371.08H574.179V5.3c1.628,1.628,2.477,2.411,4.875,4.769h-4.875v4.76h12.191V10.077L581.5,5.308h4.875Z",
    "data-name": "Path 279",
    transform: "translate(-532.456)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.a01e052b9c17e3d56ab8c464f41e33c7.svg";
export { ForwardRef as ReactComponent };